import Model from './Model';

export class Login extends Model {

	defaults() {
		return {
			auth: null,
		};
	}

	routes() {
		return {
			create: '/guest/login',
		};
	}

}

export class GetReset extends Model {

	// Default attributes that define the "empty" state.
	defaults() {
		return {
			email: '',
			turnstileToken: '',
		};
	}

	// Route configuration
	routes() {
		return {
			create: '/guest/request-password-reset',
		};
	}

}

export class Reset extends Model {

	// Default attributes that define the "empty" state.
	defaults() {
		return {
			token: '',
			newPassword: '',
		};
	}

	// Route configuration
	routes() {
		return {
			create: '/guest/password-reset?token={token}',
		};
	}

}
